export const STREAK_MIN_MIN = 360  // objetivo mínimo diario: 6 h de registro para que el día cuente para la racha

export function fmtH(min) {
  if (!min || min < 1) return '0 min'
  if (min < 60) return `${Math.round(min)} min`
  const h = Math.floor(min / 60), m = Math.round(min % 60)
  return m > 0 ? `${h}h ${m}m` : `${h} h`
}

export function fmtDate(ms) {
  const d = new Date(ms)
  const months = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic']
  return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`
}

export function fmtTime(ms) {
  const d = new Date(ms)
  const p = n => String(n).padStart(2, '0')
  return `${p(d.getHours())}:${p(d.getMinutes())}`
}

export function fmtDurationMs(ms) {
  const s = Math.floor(ms / 1000)
  const h = Math.floor(s / 3600)
  const m = Math.floor((s % 3600) / 60)
  return h > 0 ? `${h} h ${m} min` : m > 0 ? `${m} min` : `${s} s`
}

export function fmtDuration(s) {
  const h   = Math.floor(s / 3600)
  const m   = String(Math.floor((s % 3600) / 60)).padStart(2, '0')
  const sec = String(s % 60).padStart(2, '0')
  return h > 0 ? `${h}:${m}:${sec}` : `${m}:${sec}`
}

export function fmtLocalTs(ms) {
  const d = new Date(ms)
  const p = n => String(n).padStart(2, '0')
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`
}

export function fmtHMS(ts) {
  const d = new Date(ts)
  const p = n => String(n).padStart(2, '0')
  return `${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`
}

// ── Local-time date keys (Argentina UTC-3) ──────────────────────────────────
// Use these instead of `new Date(ms).toISOString().slice(...)`, which returns
// UTC and misattributes evening sessions to the next day / week / month.
// Mensaje humano para errores de red: el "Failed to fetch" crudo no ayuda a nadie
export function friendlyErr(e) {
  const m = String(e?.message || e || '')
  return (!navigator.onLine || /failed to fetch|networkerror|load failed|network request failed/i.test(m))
    ? 'Sin conexión con el servidor'
    : m
}

export function localDateKey(ms) {
  const d = new Date(ms)
  const p = n => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`
}

export function localMonthKey(ms) {
  return localDateKey(ms).slice(0, 7)
}

// Monday-anchored week key from a local 'YYYY-MM-DD' string.
export function weekKeyOf(localDateStr) {
  const d = new Date(localDateStr + 'T12:00:00')
  const day = d.getDay() || 7
  const mon = new Date(d); mon.setDate(d.getDate() - day + 1)
  const p = n => String(n).padStart(2, '0')
  return `${mon.getFullYear()}-${p(mon.getMonth() + 1)}-${p(mon.getDate())}`
}

// ISO-8601 week number (1–53) for a local 'YYYY-MM-DD' string.
export function isoWeekNum(localDateStr) {
  const d = new Date(localDateStr + 'T12:00:00')
  const dayNr = (d.getDay() + 6) % 7            // Mon=0 … Sun=6
  d.setDate(d.getDate() - dayNr + 3)            // Thursday of this week
  const firstThu = new Date(d.getFullYear(), 0, 4)
  const firstThuNr = (firstThu.getDay() + 6) % 7
  firstThu.setDate(firstThu.getDate() - firstThuNr + 3)
  return 1 + Math.round((d - firstThu) / (7 * 24 * 3600 * 1000))
}

// "Semana 25 (del 16 al 22 de jun)" — Monday-anchored week key in.
export function weekFullLabel(monIso) {
  const mon = new Date(monIso + 'T12:00:00')
  const sun = new Date(mon); sun.setDate(mon.getDate() + 6)
  const wn  = isoWeekNum(monIso)
  const moShort = dt => dt.toLocaleDateString('es-AR', { month: 'short' }).replace('.', '')
  const range = mon.getMonth() === sun.getMonth()
    ? `${mon.getDate()} al ${sun.getDate()} de ${moShort(sun)}`
    : `${mon.getDate()} ${moShort(mon)} al ${sun.getDate()} ${moShort(sun)}`
  return { wn, label: `Semana ${wn} (del ${range})`, range }
}

// Minutes of [startMs,endMs] that fall in night hours (22:00–08:00 local).
// Cheap 5-min stepping — used to flag whether a day "includes a sleep period".
export function nightOverlapMin(startMs, endMs) {
  let mins = 0
  for (let t = startMs; t < endMs; t += 5 * 60000) {
    const h = new Date(t).getHours()
    if (h >= 22 || h < 8) mins += 5
  }
  return mins
}

export function fmtLatidos(n) {
  return new Intl.NumberFormat('es-AR').format(Math.round(n || 0))
}
